import { observable, action } from 'mobx'
import { CHAT_PATH } from '@hlj/hlj-constant'
import { getWebSocketUrl } from '@util'
import ChatApi from '@api/chat'
import { getObjValue } from '@hlj/hlj-utils'

const sendByUser = payload => {
  return getObjValue(payload, 'authorObj.kind') == 0
}

class ChatSocketStore {
  constructor() {
    this.defaultDocumentTitle = document.title
    this.letterAudio = new Audio(
      'https://qnm.hunliji.com/FjhocPFqVVUxLfOOjCz5PGMZxN-L'
    )
    // 消息通知循环对象
    this.notifyLoop = {
      timeout: null,
      interval: null,
      messageId: null
    }
  }

  @observable unreadLetterCount = 0

  initSocket = () => {
    const ws = new WebSocket(getWebSocketUrl().webSocketUrl)
    ws.onopen = () => {}
    ws.onmessage = evt => {
      const data = JSON.parse(evt.data)
      const { service, subject, payload } = data
      if (service == 'ws') {
        if (subject == 'ping') {
          const msg = {
            service: 'ws',
            subject: 'pong',
            payload
          }
          ws.send(JSON.stringify(msg))
        }
      } else if (service == 'css') {
        switch (subject) {
          case 'msg.read': // 商家已读消息
            this.handleReadMessage(payload)
            break
          case 'msg': // 商家接收到消息
            this.updateUnreadCount(payload)
            break
        }
      }
    }
    ws.onclose = () => {
      setTimeout(() => this.initSocket(), 5 * 1000)
    }
  }

  /**
   * 除转接外，手动增加未读条数
   */
  updateUnreadCount = async payload => {
    const { kind } = payload

    if (kind != 'control' && sendByUser(payload)) {
      document.title = '【新私信】您有未读私信待查看～'
      this.unreadLetterCount += 1
      this.loopPlayAudio(payload.id)
    }
  }

  // 处理已读消息
  handleReadMessage = payload => {
    // 如果已读的消息和当前循环播放的消息id一致，则清除循环播放
    if (payload.message === this.notifyLoop.messageId) {
      this.clearLoopAudio()
    }
    // 获取未读消息数量 (以前的逻辑)
    this.getUnreadLetter('read')
  }

  /**
   * 获取未读私信条数，
   * 只有第一次才播放声音，后续只有接收新私信才播放
   */
  @action
  getUnreadLetter = async type => {
    const {
      data: { track_unread_count, unread_count },
      success
    } = await ChatApi.getUnreadCount()

    if (success) {
      const total = track_unread_count + unread_count
      this.unreadLetterCount = total
      if (total > 0) {
        document.title = '【新私信】您有未读私信待查看～'
      } else {
        document.title = this.defaultDocumentTitle
        // 没有未读消息则清除循环播放
        this.clearLoopAudio()
      }
      // 初始时执行循环播放
      if (total > 0 && type === 'initial') {
        this.letterAudio && this.letterAudio.play()
      }
    }
  }

  @action
  toChat = () => {
    const newTab = window.open('about:blank')
    newTab.location.href = CHAT_PATH
  }

  /**
   * 3分钟内循环播放通知, 间隔10秒.
   * @param messageId 可选，标识接收的最新的消息id
   */
  loopPlayAudio = messageId => {
    // 如果新消息之前存在定时播放，则先取消，再执行
    this.clearLoopAudio()
    this.letterAudio && this.letterAudio.play()
    this.notifyLoop.messageId = messageId
    this.notifyLoop.interval = setInterval(() => {
      this.letterAudio && this.letterAudio.play()
    }, 1000 * 10)
    this.notifyLoop.timeout = setTimeout(() => {
      clearInterval(this.notifyLoop.interval)
    }, 1000 * 60 * 3)
  }
  // 清除循环播放
  clearLoopAudio = () => {
    if (this.notifyLoop.interval) {
      clearInterval(this.notifyLoop.interval)
    }
    if (this.notifyLoop.timeout) {
      clearTimeout(this.notifyLoop.timeout)
    }
  }
}

export default new ChatSocketStore()
